import useLoad from 'components/hooks/useLoad';
import {integrityCourse} from 'constants/url';

function useLoadIntegrityCourse(selection: number) {
  return useLoad(integrityCourse, 'revision', {values: selection});
}

export default useLoadIntegrityCourse;
